var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 311,
    viewBox: "0 0 221 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45,
    clipPath: "url(#clip0_3508_3629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-49.0107 200.074L18.7363 262.401",
    stroke: "url(#paint0_linear_3508_3629)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6708 44.7163L113.246 110.848C108.281 110.288 103.27 110.239 98.2913 110.665L26.8805 44.6105C26.8805 44.6105 35.8085 43.9523 41.6722 44.7109L41.6708 44.7163Z",
    stroke: "url(#paint1_linear_3508_3629)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6709 44.7166L47.0997 23.793L118.718 89.8262L113.247 110.843L41.6709 44.7166Z",
    stroke: "url(#paint2_linear_3508_3629)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.179 196.215L95.465 129.777",
    stroke: "url(#paint3_linear_3508_3629)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-31.7274 185.102L39.1522 250.495",
    stroke: "url(#paint4_linear_3508_3629)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.531 132.062L187.328 198.493",
    stroke: "url(#paint5_linear_3508_3629)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.531 132.062L95.4664 129.77L167.179 196.213L187.328 198.492L115.531 132.062Z",
    stroke: "url(#paint6_linear_3508_3629)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.328 198.493L167.179 196.214C160.763 220.651 143.961 241.753 121.97 254.134C101.545 265.628 76.0243 269.195 54.0698 259.739C33.4533 250.856 19.7532 231.136 16.9533 209.11C13.8381 184.594 23.3971 159.524 39.6305 141.298C55.9063 123.019 79.5917 110.527 104.398 110.378C107.353 110.358 110.306 110.522 113.241 110.847L118.712 89.8253C87.2938 86.4409 56.3077 98.8931 33.3919 120.045C10.2813 141.37 -4.82191 172.103 -4.60273 203.822C-4.41041 232.36 9.55372 260.091 34.5164 274.822C60.3296 290.05 92.7709 289.096 119.647 277.272C148.825 264.442 172.55 239.552 183.737 209.745C185.122 206.053 186.282 202.297 187.322 198.492L187.328 198.493Z",
    stroke: "url(#paint7_linear_3508_3629)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4663 129.772C89.05 154.209 72.3435 175.721 50.3535 188.096C29.9289 199.59 4.40783 203.157 -17.5466 193.701C-38.1632 184.818 -51.8633 165.098 -54.6631 143.072C-57.7784 118.556 -48.2194 93.4862 -31.986 75.2597C-15.7102 56.981 7.97525 44.489 32.7815 44.3399C35.7364 44.32 38.7325 44.3856 41.6722 44.7123L47.105 23.7955C15.6827 20.4042 -15.3048 32.8618 -38.2191 54.0083C-61.3298 75.3337 -76.433 106.067 -76.2152 137.79C-76.0229 166.329 -62.0588 194.06 -37.096 208.791C-12.1333 223.522 21.1584 223.065 48.0349 211.241C77.2121 198.411 100.937 173.521 112.125 143.713C113.51 140.021 114.491 135.868 115.531 132.064L95.4649 129.777L95.4663 129.772Z",
    stroke: "url(#paint8_linear_3508_3629)",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3508_3629",
    x1: -54.5814,
    y1: 220.99,
    x2: 24.3084,
    y2: 241.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3508_3629",
    x1: 20.8793,
    y1: 64.9429,
    x2: 119.425,
    y2: 90.5386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.35
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3508_3629",
    x1: 38.3303,
    y1: 56.4468,
    x2: 122.029,
    y2: 78.1861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3508_3629",
    x1: 89.5195,
    y1: 152.136,
    x2: 173.126,
    y2: 173.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3508_3629",
    x1: -37.5736,
    y1: 207.078,
    x2: 44.9916,
    y2: 228.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3508_3629",
    x1: 109.588,
    y1: 154.41,
    x2: 193.265,
    y2: 176.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3508_3629",
    x1: 89.1515,
    y1: 150.579,
    x2: 193.629,
    y2: 177.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#8BC01F",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#8BC01F",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8BC01F",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#8BC01F",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3508_3629",
    x1: 118.599,
    y1: 89.4626,
    x2: 67.3433,
    y2: 286.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#8BC01F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#8BC01F",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#8BC01F",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3508_3629",
    x1: 46.8515,
    y1: 23.3963,
    x2: -4.40415,
    y2: 220.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3508_3629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.779,
    height: 249.197,
    fill: "white",
    transform: "translate(-44.0135 0.128906) rotate(14.5599)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame3);
export default __webpack_public_path__ + "static/media/frame3.c9bdc935d38ed2874919be2ccfcffb5d.svg";
export { ForwardRef as ReactComponent };